import AxiosAPI from '../../../utils/AxiosAPI';

export const ApiExternalLogsList = (params) => {
    return new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/logs/file/external/list?q=${params.q}`, {
                cpp: params.limit || 20,
                page: params.page || 1
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const ApiExternalLogsDelete = (fileName) => {
    return new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/logs/file/external/list/${fileName}`)
            .delete()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export default null;
